import { render } from "./ServiceCost.vue?vue&type=template&id=6d1f176e"
import script from "./ServiceCost.vue?vue&type=script&lang=js"
export * from "./ServiceCost.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__